module.exports = __webpack_public_path__ + "img/photo_2023-05-16 19.15.02.bebf7a7c.jpeg";